export interface QualityProps {
  id: string;
  title: string;
  description: string;
  imageId?: string | null;
  imageUrl?: string | null;
  displayOrder?: number;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
  image?: {
    id: string;
    url: string;
    fileName: string;
    altText?: string | null;
  } | null;
}

export class QualityEntity {
  constructor(private readonly props: QualityProps) {
    if (!props.id) throw new Error('El ID de la cualidad es obligatorio');
    if (!props.title) throw new Error('El título de la cualidad es obligatorio');
    if (!props.description) throw new Error('La descripción de la cualidad es obligatoria');
  }

  get id(): string {
    return this.props.id;
  }

  get title(): string {
    return this.props.title;
  }

  get description(): string {
    return this.props.description;
  }

  get imageId(): string | null {
    return this.props.imageId ?? null;
  }

  get imageUrl(): string | null {
    return this.props.imageUrl ?? this.props.image?.url ?? null;
  }

  get displayOrder(): number {
    return this.props.displayOrder ?? 0;
  }

  get isActive(): boolean {
    return this.props.isActive ?? true;
  }

  get status(): boolean {
    return this.isActive;
  }

  get createdAt(): string | undefined {
    return this.props.createdAt;
  }

  get updatedAt(): string | undefined {
    return this.props.updatedAt;
  }

  get image(): QualityProps['image'] {
    return this.props.image ?? null;
  }

  toJSON(): QualityProps {
    return { ...this.props };
  }
}
